import Vue from "vue/dist/vue.esm";
import SignupModal from "../../components/member/signup-modal";

document.addEventListener("DOMContentLoaded", () => {
  new Vue({ el: "#signup-modal", components: { SignupModal} });
});
